import React, {Component} from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import {get} from 'lodash'

class List extends Component {
  columns = [
    {
      Header: 'Line No',
      accessor: 'no',
      Cell: ({value, original}) => (
        <a onClick={() => this.props.onShowDelivery(original)}>{value}</a>
      ),
    },
    {
      Header: 'Order',
      accessor: 'order.code',
    },

    {
      Header: 'Stock Name',
      accessor: 'product.name',
    },
    {
      Header: 'Pick up Location',
      accessor: 'booking.pickup.label',
    },
    {
      Header: 'Pick up',
      accessor: 'booking.pickup.date',
    },
    {
      Header: 'Pick up Notes',
      accessor: 'booking.pickup.notes',
    },
    {
      Header: 'Drop off Location',
      accessor: 'booking.dropoff.label',
    },
  ]

  render() {
    const {bookings, fetch, fetching} = this.props
    return (
      <CustomTable
        columns={this.columns}
        data={bookings}
        fetch={fetch}
        fetching={fetching}
      />
    )
  }
}

List.propTypes = {}
List.defaultProps = {}

export default List
